export * from './ProspectApiClient';
export type {
  ContactDetails,
  ContactSaveRequest,
  ContactSaveResponse,
  ContactReqPayload,
} from './prospectSchema';
export {
  PROSPECT_CONTACT_PATH,
  contactDetailsSchema,
  contactSaveRequestSchema,
  contactResponseSchema,
} from './prospectSchema';
